/**
 * Atralend Brand Configuration
 * Single source of truth for all branding, contact info, and compliance details
 * Used across frontend components for consistency
 */

export const BRAND = {
  // Company
  name: "Atralend",
  legalName: "Atralend",
  tagline: "Commercial Loans Without the Bank BS",
  positioning: "The fastest path from deal to funding for Canadian property investors",
  
  // Differentiators
  differentiators: [
    "48-hour approvals (vs 60+ days at banks)",
    "No personal income requirements for commercial",
    "Lend on value, not your credit score",
    "One agent, start to finish (not a call center)"
  ],
  
  // Contact Person
  agentName: "Johnny Kulwartian",
  agentTitle: "Mortgage Agent",
  agentCredential: "Licensed Mortgage Agent - FSRA #",
  
  // Primary Contact (for customers)
  phone: "+1 613-850-2237",
  phoneFormatted: "613-850-2237",
  phoneTel: "tel:+16138502237",
  email: "Johnny@atralend.com",
  
  // System Email (for automated communications)
  systemEmail: "atralend@gmail.com",
  
  // Website
  website: "https://www.atralend.com",
  websiteDisplay: "www.atralend.com",
  
  // Location
  location: "Ottawa, Ontario, Canada",
  serviceArea: "Serving All of Canada",
  
  // Response Time Promise
  responseTime: "24hr Response Time",
  
  // Stats (for social proof)
  stats: {
    fundedLoans: "$50M+",
    avgApprovalTime: "48 hours",
    clientsSatisfied: "200+",
    defaultRate: "0%",
  },
  
  // Trust badges
  trustBadges: [
    "Licensed Mortgage Agent",
    "FSRA Regulated",
    "Serving 200+ Clients"
  ],
  
  // Social Media (add as needed)
  social: {
    // linkedin: "https://linkedin.com/in/...",
    // instagram: "https://instagram.com/...",
  },
  
  // WhatsApp for mobile click-to-chat
  whatsapp: "https://wa.me/16138502237?text=Hi%20Johnny%2C%20I%27m%20interested%20in%20commercial%20lending",
} as const;

export type BrandConfig = typeof BRAND;
